export default "__VITE_PUBLIC_ASSET__03bb838d__"